export default __webpack_public_path__ + "static/media/icon_survey_very_dissatisfied.38616f54.svg";